{
  "title": "How to Score and Formally Submit",
  "description": "Score each rubric item, save a draft, or formally submit your score.",
  "headings": [
    "What You'll Accomplish",
    "Applies To",
    "Before You Start",
    "Steps",
    "What You'll See",
    "FAQ"
  ],
  "summary": "When you're done, the score is locked and counted toward that submission's judging progress, and the screen switches to a read-only review mode.",
  "roleNote": "Judge",
  "prerequisites": [
    "You're signed in as a judge",
    "This submission is assigned to you and not excluded by a conflict of interest"
  ],
  "pathLabel": "Judge Workspace → Assignment List → Scoring Page",
  "steps": [
    {
      "title": "1. Score each rubric item",
      "description": "Each scoring item has an allowed range set by the organizer; a score outside that range is blocked before submission, and the screen names exactly which item is out of range. Every scoring item must be filled in — none can be left blank."
    },
    {
      "title": "2. Write your comments",
      "description": "The scoring form has two separate fields: \"Personal Notes\" is for your own reference only and is never shown to the organizer; \"Review Comment\" is visible to the organizer. If the competition has \"Review comment required\" enabled, you cannot formally submit without filling in the review comment."
    },
    {
      "title": "3. Save a draft",
      "description": "A score you're not yet sure about can be saved as a draft, which you can come back and edit later — it is not treated as a formal submission. Drafts also save automatically about 1.5 seconds after you stop typing (the status line shows \"Draft · saved at ...\"); only criteria you filled in are saved, never a default 0. Shortcuts: Ctrl/⌘+S save draft, Ctrl/⌘+Enter submit, Alt+←/→ previous / next."
    },
    {
      "title": "4. Formally submit",
      "description": "The \"Submit\" button stays disabled until every scoring item is filled in. Clicking \"Submit\" first opens a confirmation dialog listing your total score and each item's score for a final check (if \"Personal Notes\" is still empty, the dialog shows a warning but does not block submission); confirming in that dialog is what actually submits. The score locks immediately and the screen switches to a read-only review mode."
    }
  ],
  "afterward": [
    "The screen shows a clear success state",
    "The score is locked and you can no longer edit it yourself",
    "The scoring page offers a link to the next pending submission"
  ],
  "nextSteps": "If you later notice a mistake, contact the organizer for that competition — an organizer with the right permission can click \"Reopen\" on a locked score from the submission detail page (with a required reason) so you can revise it.",
  "faq": [
    {
      "q": "What if it says my score is out of range when I submit?",
      "a": "The screen names exactly which scoring item is out of its allowed range — adjust it according to that item's description and submit again."
    },
    {
      "q": "Can I submit a scoring form that isn't fully filled in?",
      "a": "No. The \"Submit\" button stays disabled until every scoring item is filled in, and the system blocks an incomplete submission outright. Use the completion indicator at the top of the scoring form to fill in what's missing."
    },
    {
      "q": "What if I realize I made a mistake after submitting?",
      "a": "You cannot edit a submitted score yourself. Contact the organizer — an organizer with the right permission can click \"Reopen\" on that score directly from the submission detail page and provide a reason, without you needing to file a separate request with platform administration."
    }
  ]
}
